import { Redirect } from "react-router-dom";

export function Index() {
  return <Redirect to="/dashboards/sales" />;
}
